/**
 * Xem theo
 */
export default {
  SeparateProjectSummay: 0, // Tổng hợp (Phần thu) Tách CTMT - DT tổng hợp
  NoSeparateProjectSummay: 1, // Không tách CTMT - DT tổng hợp
  SeparateProjectDetail: 2, // Chi tiết (Phần thu) Tách CTMT - DT chi tiết
  NoSeparateProjectDetail: 3, // Không tách CTMT - DT chi tiết
};